// extracted by mini-css-extract-plugin
module.exports = {"strip":"BreadCrumbStyles_strip__PmNJo","container":"BreadCrumbStyles_container__uVflp"};